(() => {
  const getDrawer = () => document.querySelector('cart-drawer');
  let badgeTimer;
  function refreshBadge() {
    clearTimeout(badgeTimer);
    badgeTimer = setTimeout(async () => {
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js');
        if (!response.ok) return;
        const cart = await response.json();
        document.querySelectorAll('.sw-bag span').forEach(el => {el.textContent = cart.item_count;});
      } catch (_) { /* Keep the last known count if the connection is interrupted. */ }
    }, 150);
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-sw-cart]');
    const drawer = getDrawer();
    if (!link || !drawer || typeof drawer.open !== 'function' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    drawer.open(link);
  });
  function init(scope = document) {
    const drawer = getDrawer();
    if (drawer && !drawer.dataset.swObserved) {
      drawer.dataset.swObserved = 'true';
      new MutationObserver(records => {
        if (records.some(record => record.target instanceof Element &&
          (record.target.id === 'CartDrawer' || record.target.id === 'CartDrawer-CartItems' ||
           [...record.addedNodes].some(node => node instanceof Element && node.querySelector('.cart-item, .cart__empty-text'))))) refreshBadge();
      }).observe(drawer, {childList:true, subtree:true});
    }
    scope.querySelectorAll('[data-sw-product]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const hero = root.querySelector('[data-hero]');
      function showImage(src, alt) {
        if (!hero || !src) return;
        hero.src = src;
        if (alt) hero.alt = alt;
        root.querySelectorAll('[data-image]').forEach(button => {
          const selected = button.dataset.image === src;
          button.setAttribute('aria-pressed', String(selected));
          if (!selected) return;
          const strip = button.closest('.sw-thumbnails');
          if (!strip || strip.scrollWidth <= strip.clientWidth) return;
          const bounds = strip.getBoundingClientRect();
          const thumb = button.getBoundingClientRect();
          const edge = thumb.width * 1.5;
          if (thumb.left < bounds.left + edge || thumb.right > bounds.right - edge) {
            // Move only the thumbnail strip, keeping the page and hero in place.
            const left = strip.scrollLeft + thumb.left - bounds.left - (strip.clientWidth - thumb.width) / 2;
            strip.scrollTo({left: Math.max(0, Math.min(left, strip.scrollWidth - strip.clientWidth)), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
          }
        });
      }
      root.querySelectorAll('[data-image]').forEach(button => button.addEventListener('click', () => showImage(button.dataset.image, button.dataset.alt)));
      root.querySelectorAll('input[name^="demo-color"]').forEach(input => input.addEventListener('change', () => {root.querySelector('[data-demo-selection]').textContent = input.value;}));
      const form = root.querySelector('.sw-form');
      if (!form) return;
      const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
      const fields = [...form.querySelectorAll('[data-option-index]')];
      const submit = form.querySelector('[type=submit]');
      const id = form.querySelector('[name=id]');
      const quantity = form.querySelector('[name=quantity]');
      const status = form.querySelector('[data-status]');
      let current;
      let busy = false;
      function update(changeImage = true) {
        const selected = fields.map(field => field.querySelector('input:checked')?.value);
        current = fields.length ? variants.find(v => v.options.every((value,i) => value === selected[i])) : variants.find(v => String(v.id) === id.value);
        fields.forEach((field,i) => field.querySelector('[data-selection]').textContent = selected[i] || '');
        id.value = current?.id || '';
        submit.disabled = busy || !current?.available || root.dataset.subscription === 'true';
        submit.innerHTML = !current ? window.nuashapeI18n.dynamic_000 : current.available ? (window.nuashapeI18n.dynamic_002 + ' <span aria-hidden="true">↗</span>') : window.nuashapeI18n.dynamic_003;
        root.querySelector('[data-price]').textContent = current?.price || window.nuashapeI18n.dynamic_004;
        const compare = root.querySelector('[data-compare]'); compare.textContent = current?.compare || ''; compare.hidden = !current?.compare;
        const saving = root.querySelector('[data-price-off]');
        saving.textContent = current?.saving ? current.saving + window.nuashapeI18n.dynamic_005 : '';
        saving.hidden = !current?.saving;
        if (current) {
          quantity.min = current.min; quantity.step = current.step;
          if(current.max) quantity.max = current.max; else quantity.removeAttribute('max');
          quantity.value = current.min;
          if (changeImage) showImage(current.image);
          const url = new URL(location.href); url.searchParams.set('variant', current.id); history.replaceState({}, '', url);
        }
        status.textContent = '';
      }
      form.addEventListener('change', event => {if(event.target.matches('[type=radio]')) update();});
      update(false);
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if(busy || !current?.available || !form.reportValidity()) return;
        busy = true; submit.disabled = true; submit.textContent = window.nuashapeI18n.dynamic_006; status.textContent = '';
        try {
          const drawer = getDrawer();
          const payload = {items:[{id:current.id,quantity:Number(quantity.value)}]};
          if (drawer && typeof drawer.renderContents === 'function') {
            payload.sections = drawer.getSectionsToRender().map(section => section.id);
            payload.sections_url = location.pathname;
            drawer.setActiveElement(submit);
          }
          const response = await fetch(root.dataset.addUrl, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
          const data = await response.json();
          if(!response.ok) throw new Error(data.description || window.nuashapeI18n.dynamic_007);
          if (drawer && payload.sections) {
            // An add can succeed even if Shopify fails to render a section.
            // Never repeat the add request in that case.
            try {
              if (!data.sections?.['cart-drawer']) {
                const rendered = await fetch((window.Shopify?.routes?.root || '/') + '?sections=' + payload.sections.join(','));
                data.sections = await rendered.json();
              }
              drawer.classList.remove('is-empty');
              drawer.renderContents(data);
              refreshBadge();
            } catch (_) {
              status.textContent = window.nuashapeI18n.dynamic_008;
              const link = document.createElement('a');
              link.href = root.dataset.cartUrl; link.textContent = window.nuashapeI18n.dynamic_009;
              status.append(link);
            }
            busy = false; submit.disabled = !current?.available; submit.innerHTML = (window.nuashapeI18n.dynamic_002 + ' <span aria-hidden="true">↗</span>');
          } else {
            location.assign(root.dataset.cartUrl);
          }
        } catch(error) {status.textContent = error.message; busy = false; submit.disabled = !current?.available; submit.innerHTML = (window.nuashapeI18n.dynamic_002 + ' <span aria-hidden="true">↗</span>');}
      });
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

// Shared worldwide countdown, followed by synchronized four-hour cycles.
(() => {
  function startSaleTimer() {
    const bar = document.querySelector('[data-sale-end]');
    if (!bar || bar.dataset.timerReady) return;
    const end = Date.parse(bar.dataset.saleEnd);
    if (!Number.isFinite(end)) return;
    bar.dataset.timerReady = 'true';
    function tick() {
      const now = Date.now();
      const cycle = 4 * 60 * 60 * 1000;
      const remaining = now < end ? end - now : cycle - ((now - end) % cycle);
      const seconds = Math.ceil(remaining / 1000);
      const values = {days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24, minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60};
      Object.entries(values).forEach(([key, value]) => { bar.querySelector('[data-sale-' + key + ']').textContent = String(value).padStart(2, '0'); });
      document.querySelectorAll('[data-promo-card]').forEach(card => {
        Object.entries(values).forEach(([key, value]) => { card.querySelector('[data-promo-' + key + ']').textContent = String(value).padStart(2, '0'); });
        card.hidden = false;
      });
      bar.hidden = false;
      return true;
    }
    if (tick()) { const timer = setInterval(() => { if (!bar.isConnected || !tick()) clearInterval(timer); }, 1000); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startSaleTimer); else startSaleTimer();
  document.addEventListener('shopify:section:load', startSaleTimer);
})();

(() => {
  document.querySelectorAll('[data-country-flag]').forEach(flag => {
    const code = flag.dataset.countryFlag.toUpperCase();
    if (/^[A-Z]{2}$/.test(code)) flag.textContent = String.fromCodePoint(...Array.from(code, char => 127397 + char.charCodeAt(0)));
  });
  const cards = document.querySelectorAll('[data-delivery]');
  if (!cards.length) return;
  const format = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', { month: 'short', day: 'numeric' });
  const deliveryTimerKey = 'nuashape-delivery-deadline';
  let deliveryDeadline = Date.now() + 4 * 60 * 60 * 1000;
  try {
    const saved = Number(localStorage.getItem(deliveryTimerKey));
    if (saved > 0 && Number.isFinite(saved)) deliveryDeadline = saved;
    else localStorage.setItem(deliveryTimerKey, String(deliveryDeadline));
  } catch (_) {}
  function updateDelivery() {
    const now = new Date();
    if (deliveryDeadline <= now.getTime()) {
      deliveryDeadline = now.getTime() + 4 * 60 * 60 * 1000;
      try { localStorage.setItem(deliveryTimerKey, String(deliveryDeadline)); } catch (_) {}
    }
    const remaining = Math.max(0, Math.floor((deliveryDeadline - now.getTime()) / 1000));
    const countdown = [Math.floor(remaining / 3600), Math.floor(remaining / 60) % 60, remaining % 60].map(n => String(n).padStart(2, '0')).join(':');
    const transitGroups = [
      { countries: ['BE','CA','IE','NL','US'], days: [5,7] },
      { countries: ['AT','HR','CZ','EE','FI','FR','DE','GR','HU','IT','LV','LT','RO','SK','SI','ES','CH','GB'], days: [6,9] },
      { countries: ['BG','CY','DK','LU','MT','PL','PT','SE'], days: [8,11] }
    ];
    function addBusinessDays(date, count) {
      const result = new Date(date);
      result.setHours(12, 0, 0, 0);
      while (count > 0) {
        result.setDate(result.getDate() + 1);
        if (result.getDay() !== 0 && result.getDay() !== 6) count--;
      }
      return result;
    }
    cards.forEach(card => {
      const country = (card.querySelector('[data-country-flag]')?.dataset.countryFlag || '').toUpperCase();
      const transit = transitGroups.find(group => group.countries.includes(country))?.days || [10,15];
      const minimum = transit[0] + 2;
      const maximum = transit[1] + 4;
      const first = addBusinessDays(now, minimum);
      const last = addBusinessDays(now, maximum);
      first.setDate(first.getDate() - 4);
      last.setDate(last.getDate() - 4);
      card.querySelector('[data-delivery-countdown]').textContent = countdown;
      card.querySelector('[data-delivery-dates]').textContent = window.nuashapeI18n.dynamic_010;
      card.hidden = false;
    });
  }
  updateDelivery();
  setInterval(updateDelivery, 1000);
})();

// Delegation keeps size-guide controls working after theme preview updates.
(() => {
  let opener;
  document.addEventListener('click', event => {
    const openButton = event.target.closest('[data-size-open]');
    if (openButton) {
      const dialog = openButton.closest('[data-sw-product]')?.querySelector('.sw-size-dialog') || document.querySelector('.sw-size-dialog');
      if (!dialog) return;
      event.preventDefault();
      opener = openButton;
      if (!dialog.open) dialog.showModal();
      return;
    }
    const closeButton = event.target.closest('[data-size-close]');
    if (closeButton) closeButton.closest('dialog')?.close();
    if (event.target.matches('dialog.sw-size-dialog')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('close', event => {
    if (event.target.matches('.sw-size-dialog')) opener?.focus();
  }, true);
})();

(() => {
  document.querySelectorAll('.sw-stories').forEach(section => {
    const thumbs = [...section.querySelectorAll('[data-story-src]')];
    const previews = [...section.querySelectorAll('.sw-story-preview')];
    const visiblePreviews = new Set();
    function syncPreviews() {
      previews.forEach(preview => {
        if (preview.parentElement === dialog) return;
        preview.muted = true;
        if (visiblePreviews.has(preview) && !document.hidden && !section.querySelector('dialog').open) {
          if (!preview.getAttribute('src')) preview.src = preview.dataset.previewSrc;
          preview.play().catch(() => {});
        } else preview.pause();
      });
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.isIntersecting && entry.intersectionRatio >= 0.35) visiblePreviews.add(entry.target); else visiblePreviews.delete(entry.target); });
      syncPreviews();
    }, {threshold: [0, 0.35]});
    previews.forEach(preview => observer.observe(preview));
    document.addEventListener('visibilitychange', syncPreviews);
    const dialog = section.querySelector('dialog');
    const videoSlot = dialog.querySelector('video');
    let video = videoSlot;
    const loading = dialog.querySelector('.sw-story-loading');
    const progress = dialog.querySelector('.sw-story-progress');
    progress.replaceChildren(...thumbs.map(() => {
      const segment = document.createElement('span');
      segment.className = 'sw-story-segment';
      segment.append(document.createElement('i'));
      return segment;
    }));
    const fills = [...progress.querySelectorAll('i')];
    const toggle = dialog.querySelector('.sw-story-toggle');
    const sound = dialog.querySelector('.sw-story-sound');
    toggle.addEventListener('click', () => { if(video.paused) video.play().catch(() => {}); else video.pause(); });
    sound.addEventListener('click', () => {
      video.muted = !video.muted;
      storyMuted = video.muted;
      sound.textContent = video.muted ? window.nuashapeI18n.dynamic_011 : window.nuashapeI18n.dynamic_012;
      sound.setAttribute('aria-label', video.muted ? window.nuashapeI18n.dynamic_013 : window.nuashapeI18n.dynamic_014);
    });
    let index = 0;
    let storyMuted = false;
    function restorePreview() {
      if (video === videoSlot) return;
      video.pause();
      video.muted = true;
      video.loop = true;
      video.replaceWith(videoSlot);
      thumbs[index].prepend(video);
      video = videoSlot;
    }
    previews.forEach(preview => {
      const active = () => dialog.open && video === preview;
      preview.addEventListener('playing', () => { if (active()) loading.hidden = true; });
      preview.addEventListener('waiting', () => { if (active()) loading.hidden = false; });
      preview.addEventListener('error', () => { if (active()) { loading.textContent = window.nuashapeI18n.dynamic_015; loading.hidden = false; } });
      preview.addEventListener('play', () => { if (active()) { toggle.classList.remove('is-paused'); toggle.setAttribute('aria-label', window.nuashapeI18n.dynamic_016); } });
      preview.addEventListener('pause', () => { if (active()) { toggle.classList.add('is-paused'); toggle.setAttribute('aria-label', window.nuashapeI18n.dynamic_017); } });
      preview.addEventListener('ended', () => { if (active()) { if (index < thumbs.length - 1) play(index + 1); else dialog.close(); } });
      preview.addEventListener('timeupdate', () => { if (active() && fills[index]) fills[index].style.width = (preview.duration ? preview.currentTime / preview.duration * 100 : 0) + '%'; });
    });
    function play(i) {
      restorePreview();
      index = (i + thumbs.length) % thumbs.length;
      video = previews[index];
      // Move the already-buffered player; assigning src again discards its buffer.
      videoSlot.replaceWith(video);
      video.loop = false;
      video.muted = storyMuted;
      video.preload = 'auto';
      if (!video.getAttribute('src')) video.src = video.dataset.previewSrc;
      loading.textContent = window.nuashapeI18n.dynamic_018;
      loading.hidden = video.readyState >= 3;
      sound.textContent = video.muted ? window.nuashapeI18n.dynamic_011 : window.nuashapeI18n.dynamic_012;
      sound.setAttribute('aria-label', video.muted ? window.nuashapeI18n.dynamic_013 : window.nuashapeI18n.dynamic_014);
      fills.forEach((fill, n) => { fill.style.width = n < index ? '100%' : '0%'; });
      const selected = video;
      video.play().catch(error => { if (video === selected && dialog.open && error.name !== 'AbortError') { loading.textContent = window.nuashapeI18n.dynamic_019; loading.hidden = false; toggle.classList.add('is-paused'); } });
    }
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => {
      const root = section.closest('[data-sw-product], [data-story-home]');
      const price = dialog.querySelector('.sw-story-price');
      price.replaceChildren();
      const compare = root.querySelector('[data-compare]');
      if (compare && !compare.hidden && compare.textContent.trim()) {
        const original = document.createElement('s');
        original.textContent = compare.textContent;
        price.append(original);
      }
      const currentPrice = document.createElement('span');
      currentPrice.textContent = root.querySelector('[data-price]').textContent;
      price.append(currentPrice);
      const saving = root.querySelector('[data-price-off]');
      if (saving && !saving.hidden) { const badge = document.createElement('em'); badge.textContent = saving.textContent; price.append(badge); }
      dialog.showModal(); syncPreviews(); play(i);
    }));
    dialog.querySelector('.sw-story-close').addEventListener('click', () => dialog.close());
    dialog.querySelector('.sw-story-prev').addEventListener('click', () => play(index - 1));
    dialog.querySelector('.sw-story-next').addEventListener('click', () => play(index + 1));
    dialog.addEventListener('close', () => { restorePreview(); thumbs[index]?.focus(); syncPreviews(); });
    dialog.querySelector('.sw-story-product').addEventListener('click', () => {
      dialog.close();
      const home = section.closest('[data-story-home]');
      if (home) { window.location.assign(home.dataset.productUrl); return; }
      const target = section.closest('[data-sw-product]').querySelector('.sw-purchase');
      target.scrollIntoView({behavior: 'smooth', block: 'center'});
    });
  });
})();

// Review navigation remains delegated for theme editor section reloads.
document.addEventListener('click', function(event) {
  const control = event.target.closest('[data-review-direction]');
  if (!control) return;
  const track = control.closest('.sw-reviews').querySelector('.sw-reviews-track');
  const card = track.querySelector('.sw-review-card');
  if (card) track.scrollBy({left: Number(control.dataset.reviewDirection) * (card.getBoundingClientRect().width + 14), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
});

// Native dialog provides focus containment, Escape dismissal and focus restoration.
document.addEventListener('click', (event) => {
  const menu = document.getElementById('sw-navigation');
  if (!menu) return;
  if (event.target.closest('.sw-menu-toggle')) menu.showModal();
  if (event.target.closest('[data-menu-close]') || event.target.closest('.sw-navigation nav a')) menu.close();
  if (event.target === menu) {
    const rect = menu.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) menu.close();
  }
});

// Mobile shortcut back to the product's size selection.
(() => {
  const root = document.querySelector('[data-sw-product]');
  const purchase = root?.querySelector('.sw-purchase');
  const size = root?.querySelector('.sw-size-inline')?.closest('fieldset');
  if (!purchase || !size) return;
  const shortcut = document.createElement('button');
  shortcut.type = 'button';
  shortcut.className = 'sw-mobile-size-cta sw-cta';
  shortcut.textContent = window.nuashapeI18n.dynamic_020;
  const arrow = document.createElement('span');
  arrow.textContent = '↗';
  arrow.setAttribute('aria-hidden', 'true');
  shortcut.append(arrow);
  shortcut.hidden = true;
  document.body.append(shortcut);
  let scheduled = false;
  function update() {
    scheduled = false;
    const header = document.querySelector('.sw-sticky-header');
    shortcut.hidden = purchase.getBoundingClientRect().bottom > (header?.getBoundingClientRect().bottom || 0);
  }
  function schedule() {
    if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
  }
  window.addEventListener('scroll', schedule, { passive:true });
  window.addEventListener('resize', schedule);
  shortcut.addEventListener('click', () => {
    const headerHeight = document.querySelector('.sw-sticky-header')?.getBoundingClientRect().height || 0;
    const top = window.scrollY + size.getBoundingClientRect().top - headerHeight - 16;
    window.scrollTo({ top, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    const selected = size.querySelector('input:checked') || size.querySelector('input');
    selected?.focus({ preventScroll:true });
  });
  update();
})();

// Silent inline loops used as animated product demonstrations.
(() => {
  const videos = [...document.querySelectorAll('.sw-favorite-video, .sw-zero-thoughts > video')];
  if (!videos.length) return;
  const visible = new Set();
  const play = video => {
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.controls = false;
    video.play().catch(() => {});
  };
  const observer = new IntersectionObserver(entries => {
    entries.forEach(({target, isIntersecting}) => {
      if (isIntersecting) { visible.add(target); play(target); }
      else { visible.delete(target); target.pause(); }
    });
  }, {threshold: .05});
  videos.forEach(video => {
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('muted', '');
    video.setAttribute('disablepictureinpicture', '');
    video.addEventListener('loadeddata', () => { if (visible.has(video)) play(video); });
    video.addEventListener('click', () => play(video));
    observer.observe(video);
  });
  const resume = () => { if (!document.hidden) visible.forEach(play); };
  document.addEventListener('touchend', resume, {passive:true});
  document.addEventListener('pointerup', resume, {passive:true});
  document.addEventListener('visibilitychange', resume);
  window.addEventListener('pageshow', resume);
})();


// Desktop purchase shortcut with current product context.
(() => {
  const root = document.querySelector('[data-sw-product]');
  const purchase = root?.querySelector('.sw-purchase');
  const mobile = document.querySelector('.sw-mobile-size-cta');
  if (!purchase || !mobile) return;
  const bar = document.createElement('aside');
  bar.className = 'sw-desktop-purchase';
  bar.setAttribute('aria-label', window.nuashapeI18n.dynamic_021);
  const photo = document.createElement('img');
  photo.src = root.querySelector('.sw-gallery img')?.src || '';
  photo.alt = ''; photo.width = 48; photo.height = 58;
  const info = document.createElement('div');
  info.className = 'sw-desktop-purchase-info';
  const title = document.createElement('strong');
  title.textContent = root.querySelector('h1').textContent;
  const price = document.createElement('div');
  price.className = 'sw-desktop-purchase-price';
  const syncPrice = () => {
    price.replaceChildren();
    const original = root.querySelector('.sw-price');
    [...original.children].forEach(node => {
      if (node.hidden) return;
      const copy = node.cloneNode(true);
      [...copy.attributes].filter(a => a.name.startsWith('data-')).forEach(a => copy.removeAttribute(a.name));
      price.append(copy);
    });
  };
  syncPrice();
  new MutationObserver(syncPrice).observe(root.querySelector('.sw-price'), {childList:true, subtree:true, attributes:true, characterData:true});
  info.append(title, price);
  const button = document.createElement('button');
  button.type = 'button'; button.className = 'sw-cta';
  button.textContent = window.nuashapeI18n.dynamic_020;
  button.addEventListener('click', () => mobile.click());
  bar.append(photo, info, button); bar.hidden = true;
  document.body.append(bar);
  let queued = false;
  const update = () => {
    queued = false;
    const headerBottom = document.querySelector('.sw-sticky-header')?.getBoundingClientRect().bottom || 0;
    bar.hidden = !matchMedia('(min-width: 1000px)').matches || purchase.getBoundingClientRect().bottom > headerBottom;
  };
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', schedule);
  update();
})();
